import { gql } from '@apollo/client'

const REQUEST_FIELDS = `
  _id month timezone companyId projectId categoryId personId proposedMinutes
  approvedMinutes reason authorId status idempotencyKey version approverId
  approvedAt decisionReason estimateId createdAt
`

export const GET_MY_ESTIMATE_REQUESTS = gql`
  query getMyEstimateRequests {
    getMyEstimateRequests {
      ${REQUEST_FIELDS}
      company { _id name }
      project { _id name }
      category { _id name }
      person { _id firstName lastName }
      history { decision at proposedMinutes approvedMinutes reason previousVersion nextVersion estimateId }
    }
  }
`

export const GET_ESTIMATE_REQUESTS = gql`
  query getEstimateRequests {
    getEstimateRequests {
      ${REQUEST_FIELDS}
      company { _id name }
      project { _id name }
      category { _id name }
      person { _id firstName lastName }
      author { _id firstName lastName }
      history { decision at proposedMinutes approvedMinutes reason previousVersion nextVersion estimateId }
    }
  }
`

export const ESTIMATE_REQUEST_CREATE = gql`
  mutation estimateRequestCreate($input: EstimateRequestCreateInput!) {
    estimateRequestCreate(input: $input) { ${REQUEST_FIELDS} status version }
  }
`

export const ESTIMATE_REQUEST_DECIDE = gql`
  mutation estimateRequestDecide($id: ID!, $input: EstimateRequestDecisionInput!) {
    estimateRequestDecide(id: $id, input: $input) { ${REQUEST_FIELDS} status version }
  }
`
